export default "__VITE_ASSET__CjbZzy6g__"